module.exports = __webpack_public_path__ + "img/nt-active.9f3a393d.png";